import http from '../http/http';

import { generateEndpoint, ADDRESSES_BY_POSTCODE } from '../http/endpoints';

export default (() => {
    const findByPostcode = (postcode) =>
        http.get(
            generateEndpoint(ADDRESSES_BY_POSTCODE, {
                postcode,
            })
        );

    return {
        findByPostcode,
    };
})();
